package org.lennycodes.hldi.backend.db_service

import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.onAuthStateChanged
fun observeAuth(
    callback: (Boolean) -> Unit
) {

    onAuthStateChanged(
        FirebaseService.auth
    ) { user ->

        console.log(
            "Auth state changed: ${user?.email}"
        )

        callback(user != null)

    }

}